import {
  BilletoEventOverviewType,
  mapBillettoEventToLinkListData,
} from "@/getData/fetchBillettoData";
import LinkListModule, {
  LinkListModuleType,
} from "../LinkListModule/LinkListModule";
import { LinkListOptionsType } from "@/types/ModuleOptionsType";
import { useGlobalContext } from "@aleksundshantu/aunds-utils-react/contexts";

type BillettoLinkListProps = {
  billettoEvents: BilletoEventOverviewType[];
  linkListData: LinkListModuleType;
  linkListOptions: LinkListOptionsType;
};

const BillettoLinkList = ({
  billettoEvents,
  linkListData,
  linkListOptions,
}: BillettoLinkListProps) => {
  const { getIcon, getLabel } = useGlobalContext();
  const mappedData = mapBillettoEventToLinkListData(billettoEvents, {
    icon: getIcon("liEventNobleBC"),
    ariaLabel: getLabel("aria_label_billetto_event_icon"),
    linkTitle: getLabel("link_title_billetto_single_event"),
  });

  return (
    <LinkListModule
      linkListOptions={linkListOptions}
      isNobleElements={false}
      data={{
        ...linkListData,
        linklist: { ...linkListData.linklist, elements: mappedData },
      }}
    />
  );
};

export default BillettoLinkList;
